import { IOption } from './../../types/items'


export const SHiddenOptions: IOption[] = [
  { value: 'true', slug: 'yes' },
  { value: 'false', slug: 'no' }
]